import { render, staticRenderFns } from "./ImportProjectPlansPage.vue?vue&type=template&id=42de3e96&scoped=true"
import script from "./ImportProjectPlansPage.vue?vue&type=script&lang=ts"
export * from "./ImportProjectPlansPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42de3e96",
  null
  
)

export default component.exports